module.exports = __webpack_public_path__ + "static/media/NotoSansKR-Regular.53e1309e.woff";